<script lang="ts">
    import ColoredModal from "../colored/ColoredModal.svelte";
    import ColoredButton from "../colored/ColoredButton.svelte";
    import { P } from "flowbite-svelte";

    let {isOpen = $bindable(), close}: {
        isOpen: boolean,
        close: () => void
    } = $props();

</script>

<ColoredModal title="Enable No Sleep" autoclose bind:open={isOpen}>
    <P class="black:text-white frappe:text-ctp-subtext0">Click 'Okay' to enable No Sleep. This prevents the computer
        from going to sleep.</P>

    <P class="black:text-white frappe:text-ctp-subtext0">You have to do this every time you refresh the page, sorry,
        it's the only way.</P>

    {#snippet footer()}
        <ColoredButton onclick={close} class="me-2">Okay</ColoredButton>
    {/snippet}
</ColoredModal>
